<p8-layout-settings-page>
  <mat-progress-bar [mode]="'indeterminate'" *ngIf="loadingResponse"></mat-progress-bar>
  <app-reponse-fiche *ngIf="response" [response]="response" [indexAvis]="route.snapshot.data?.indexAvis"></app-reponse-fiche>
  <p8-layout-settings-footer [flexLayoutAlign]="'end'">
    <button mat-raised-button (click)="listResponses()" *ngIf="response">Retour liste demandes du formulaire</button>
  </p8-layout-settings-footer>
</p8-layout-settings-page>
